import React, { useMemo } from "react";
import gauge1 from "../../../assets/images/barometer/evidens_barometer_1.png";
import gauge2 from "../../../assets/images/barometer/evidens_barometer_2.png";
import gauge3 from "../../../assets/images/barometer/evidens_barometer_3.png";
import gauge4 from "../../../assets/images/barometer/evidens_barometer_4.png";
import gauge5 from "../../../assets/images/barometer/evidens_barometer_5.png";
import gauge6 from "../../../assets/images/barometer/evidens_barometer_6.png";

const gaugeMap = new Map<number, string>([
  [1, gauge1],
  [2, gauge2],
  [3, gauge3],
  [4, gauge4],
  [5, gauge5],
  [6, gauge6],
]);

interface Props {
  className?: string;
  evidence: number | undefined;
}

export function Gauge({ className, evidence }: Props) {
  const img = useMemo(() => {
    return gaugeMap.get(evidence ?? 1);
  }, [evidence]);

  return <img src={img} alt="evidence_image" className="w-full"></img>;
}
